(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('mh-header-chat')) {
    customElements.define('mh-header-chat', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.label = this.link.querySelector('span');
        this.originalLabel = this.label.textContent;
        this.onClick = this.openChat.bind(this);
        this.link.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.link.removeEventListener('click', this.onClick);
        clearTimeout(this.timer);
      }

      openChat(event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        if (this.link.getAttribute('aria-busy') === 'true') return;
        this.link.setAttribute('aria-busy', 'true');
        this.label.textContent = this.link.dataset.loadingLabel;
        const deadline = Date.now() + 5000;
        const tryOpen = () => {
          const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
          const runtimeRoot = chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
          const root = runtimeRoot || chatRoot;
          const launcher = root?.querySelector('button[part~="activator"]');
          if (launcher) {
            if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
            this.link.removeAttribute('aria-busy');
            this.label.textContent = this.originalLabel;
          } else if (Date.now() < deadline && this.isConnected) {
            this.timer = setTimeout(tryOpen, 150);
          } else {
            this.link.removeAttribute('aria-busy');
            this.label.textContent = this.originalLabel;
            window.location.assign(this.link.href);
          }
        };
        this.timer = setTimeout(tryOpen, 0);
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-tshirt-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mh-local-quote')) {
    customElements.define('mh-local-quote', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const dialog = this.querySelector('.mh-local__dialog');
        if (!dialog) return;
        this.dialog = dialog;
        this.addEventListener('click', (event) => {
          const openButton = event.target.closest('[data-local-quote-open]');
          if (openButton && !dialog.open) {
            dialog.showModal();
            dialog.scrollTop = 0;
            document.documentElement.classList.add('mh-local-quote-open');
            dialog.querySelector('[data-local-quote-close]').focus({ preventScroll: true });
          }
          if (event.target.closest('[data-local-quote-close]')) dialog.close();
        }, options);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('mh-local-quote-open');
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        document.documentElement.classList.remove('mh-local-quote-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
